import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import Constants from './Constants';
import ApiManager from './ApiManager';

class CountriesStore extends ReduceStore {
  /**
   * We avoid hitting the API more than once.
   * @type {boolean}
   */
  apiFetchDidCompleteAtLeastOnce = false;

  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.GET_COUNTRIES:
        // If we already got a response from the server, we just return it.
        // .slice(0) creates a new array, which is needed for the Dispatcher to
        // dispatch a "change" event.
        if (this.apiFetchDidCompleteAtLeastOnce) {
          return this.getState().slice(0);
        }

        ApiManager.getCountries();
        return state;

      case Constants.COUNTRIES_CHANGED:
        this.apiFetchDidCompleteAtLeastOnce = true;
        return action.countries;

      default:
        return state;
    }
  }

  find(id) {
    return this.getState().find(country => country.id === id);
  }
}

export default new CountriesStore();



// WEBPACK FOOTER //
// ./src/flux/CountriesStore.js